import { render, staticRenderFns } from "./EventosCalendario.vue?vue&type=template&id=564ed3bd&scoped=true&"
import script from "./EventosCalendario.vue?vue&type=script&lang=js&"
export * from "./EventosCalendario.vue?vue&type=script&lang=js&"
import style0 from "./EventosCalendario.vue?vue&type=style&index=0&id=564ed3bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ed3bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
installComponents(component, {VCalendar})
